(function () {
'use strict';

angular
    .module('surveyRoutes', [
        'surveyCampaignRoutes',
        'surveyControllers'
    ])
    .config(routeur);

routeur.$inject = ['$stateProvider', '$urlRouterProvider'];

function routeur($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('survey', {
            url: '/Survey',
            templateUrl: require('./survey.tpl.html'),
            controller: 'SurveyController',
        })

        // Available Surveys
        .state('survey.available', {
            url: '/Available',
            views: {
                'disclaimerContent@survey': {
                    templateUrl: require('./availableSurveys.tpl.html'),
                    controller: 'AvailableSurveysController',
                    resolve: {
                        availableSurveys: ['surveyService', function (service) {
                            return service.getAvailableSurveys();
                        }]
                    },
                }
            }
        })
            
        // Survey To Respond
        .state('survey.forRespondent', {
            url: '/{Year}/{Month}/{Day}/{Title}',
            resolve: {
                survey: ['$stateParams', 'surveyService', function ($stateParams, service) {
                    return service.getSurvey($stateParams);
                }]
            },
            views: {
                'disclaimerContent@survey': {
                    template: '',
                    controller: 'SurveyRespondentController'
                }
            }
        })

        .state('survey.forRespondent.notAvailable', {
            url: '/NotAvailable',
            views: {
                'disclaimerContent@survey': {
                    templateUrl: require('./surveyNotAvailable.tpl.html'),
                    controller: 'SurveyNotAvailableController'
                }
            }
        })

        .state('survey.forRespondent.welcome', {
            url: '/Welcome',
            views: {
                'disclaimerContent@survey': {
                    templateUrl: require('./welcome.tpl.html'),
                    controller: 'SurveyRespondentController'
                }
            }
        })

        .state('survey.forRespondent.completed', {
            url: '/Completed',
            views: {
                'disclaimerContent@survey': {
                    templateUrl: require('./completed.tpl.html'),
                    controller: 'SurveyRespondentController'
                }
            }
        })

        .state('survey.forRespondent.page', {
            url: '/Page/{PageNumber}',
            resolve: {
                page: ['$stateParams', 'surveyService', function ($stateParams, service) {
                    return service.getPage($stateParams, $stateParams.PageNumber);
                }]
            },
            views: {
                'disclaimerContent@survey': {
                    template: '',
                },
                'surveyPageContent@survey': {
                    templateUrl: require('./surveyRespondentPage.tpl.html'),
                    controller: 'SurveyRespondentPageController'
                }
            },
        });
}
})();